<fury-page-layout mode="card">
    <fury-page-layout-header>
      <div class="headFlex">
        <fury-breadcrumbs [@fadeInRight]  current="Copay Fee Content"></fury-breadcrumbs>
        <button mat-button [routerLink]="['/settings/copay-fee/edit-copay-fee-text']" class="sub-button"><span>Update Content</span></button>
      </div>
     
    </fury-page-layout-header>
    <fury-page-layout-content [@fadeInUp]>
      <div fxLayout="column" fxLayoutAlign="start center">
        <div [@fadeInUp] class="card">
            <p *ngIf="isLoading">Please wait...</p>
            <div *ngIf="!isLoading">
                <div class="contentprt">
                    <h3>Copay Fee Text</h3>
                    <div [innerHTML]="copayFeeData?.text"></div>
                </div>
            </div>
        </div>
      </div>
    </fury-page-layout-content>
  </fury-page-layout>
  